import PhotoSwipe from 'photoswipe';
import { NAVIGATE_BACK_MODEL } from './navigate-back-model';

export const openGalleryHandler = (instance: PhotoSwipe) => {
  instance.on('close', () => {
    NAVIGATE_BACK_MODEL.galleryClosed();
  });
  NAVIGATE_BACK_MODEL.galleryOpened(instance);
};
